import { render } from "./jmxzdm.vue?vue&type=template&id=68ebadea"
import script from "./jmxzdm.vue?vue&type=script&lang=js"
export * from "./jmxzdm.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__